import axios from "axios";

const baseURL = process.env.REACT_APP_API_KEY;

const epGetOrganizationData = (guid) => {
    return axios.get(`${baseURL}/externalhb/getOrganizationData/${guid}`);
}

const epGetOrganizationData32 = (guid) => {
    return axios.get(`${baseURL}/externalhb/getOrganizationData32/${guid}`);
}

const epSendHBData = (formData) => {
    return axios.post(`${baseURL}/externalhb/SendHBData`, formData);
}

const epSendClientData = (formData) => {
    return axios.post(`${baseURL}/externalhb/SendClientData`, formData);
}

const api = { epGetOrganizationData,epGetOrganizationData32, epSendHBData,epSendClientData };
export default api;